<template>
  <b-navbar sticky toggleable="sm" type="light" variant="light" class="border-bottom">
    <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
    <b-navbar-brand :to="{ name: 'home' }">ERP Middleware</b-navbar-brand>
    <b-collapse is-nav id="nav_collapse">
      <portal-target name="search" slim></portal-target>
      <user-nav class="ml-auto"></user-nav>
    </b-collapse>
  </b-navbar>
</template>

<script>
import { mapGetters } from "vuex";

import UserNav from "@app/components/navigation/UserNav";

export default {
  components: {
    UserNav
  },

  computed: {
    ...mapGetters(["isLoggedIn"])
  }
};
</script>
